import { Trans, useTranslation } from 'react-i18next';
import truImg from '../../Assets/Images/solutions-true.svg';
import marketImg from '../../Assets/Images/market-image.png';
import { useSelector } from 'react-redux';

export default function MarketSolutions() {
  const { t } = useTranslation();
  const { language } = useSelector((state) => state.lang);
  const cards = t('solutions.market.cards', { returnObjects: true });
  return (
    <div className="solutions__market" dir="ltr">
      <div className="solutions__market-img" style={{ order: 1 }}>
        <img src={marketImg} alt="market solutions" loading="lazy" />
        <p
          dangerouslySetInnerHTML={{
            __html: t('solutions.market.paragraph'),
          }}
        />
      </div>
      <div className="solutions__market-cards" style={{ order: 2 }}>
        {cards.map((card, index) => (
          <div
            key={index}
            className="solutions__market-cards--item"
            dir={language === 'ar' ? 'rtl' : 'ltr'}
          >
            <img src={truImg} alt={`${card.title}`} loading="lazy" />
            <div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
